import type { FaireProductEntity } from "../../entity_types/product";

export const p_e6dgxpzrbd: FaireProductEntity = {
  token: "p_e6dgxpzrbd",
  type: "product",
  name: "Rowan Plaid Smocked Mini Dress",
  brandToken: "b_2mvdyzg3tq",
  brandName: "Olivaceous",
  imageUrl:
    "https://cdn.faire.com/fastly/c166ddc0dfb7617098465267d1abcfcdf713a2c639cf50d178057881cbaa729f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3b6cc3ff83a804062d3a99c1df7597fa419131535618accf458f5362b6798490.jpeg",
    "https://cdn.faire.com/fastly/1ccd835557c080993053de0a9a21f4b9fcd9a984fe9e99de8068682e88085858.jpeg",
    "https://cdn.faire.com/fastly/88077635bc4eed5bf437d27fa38abd4def233429f835465ecff9bd5085a2b946.jpeg",
    "https://cdn.faire.com/fastly/bdf32a9dac43740bec9075c9b012d5b1b391f542d9d6b18883e6cb7e9a8280ea.jpeg",
    "https://cdn.faire.com/fastly/3f4fa3ace6057fd44d15d680ccdb9f0e9ec06e0f4f29ccbe3671a8181a8d3268.jpeg",
    "https://cdn.faire.com/fastly/fe61ce24ffeb492415f1890365dc767f4cef4d8b17bf19bf4a1070e0a65d3cd2.jpeg",
    "https://cdn.faire.com/fastly/fb9d57577b91017b0330fd0f655a3155ed480c5b3ae7fcc0ba3d451c5bde0722.jpeg",
    "https://cdn.faire.com/fastly/5fb8e26045d96768f43cf16779bb848217449b801f90b7e861dbe813129cee42.jpeg",
    "https://cdn.faire.com/fastly/ac330d6f8181aaeb0ee9da419b0d03c3dd0d71937c34b126e7af4b6a5552f0c8.jpeg",
    "https://cdn.faire.com/fastly/35ef2fc92785bad6e5ff7f9aa9a28945500be838e0bdc07fd827a7c4bc57bab2.jpeg",
  ],
  priceDollars: 223.13,
  description:
    "Our Rowan Plaid Smocked Mini Dress features a structured fit-and-flare silhouette with a timeless plaid pattern for an effortlessly polished look. Designed with cap sleeves, a fitted smocked bodice, and a softly gathered skirt, it creates a flattering feminine shape while keeping a lightweight comfortable feel perfect for everyday outings and elevated daytime styling.\n\nWoven",
  tags: [],
  msrpDollars: 446.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:17:56.344Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
